/**
 * Guía: Idiomas.
 *
 * Contenido derivado del capítulo **04** del manual: §0 (el gemelo
 * estructural de Monedas, y el aviso de que el idioma **no traduce nada**).
 *
 * Ese aviso es la razón de que esta guía exista: es la confusión que produce
 * la pantalla, y la que lleva a esperar que la app cambie de idioma sola.
 */

import type { TourFlow } from '../types';

const IDIOMAS_PATH = '/languages';

export const c04Idiomas: TourFlow = {
  id: 'admin.languages',
  chapter: '04',
  title: 'Idiomas',
  summary:
    'El catálogo de idiomas de los países, y por qué poner uno aquí no traduce nada.',
  href: IDIOMAS_PATH,
  estimatedMin: 2,
  steps: [
    {
      id: 'intro',
      title: 'El gemelo de Monedas',
      body:
        'Mismo patrón, mismos permisos y misma regla: un idioma es prerrequisito para dar ' +
        'de alta un país, y no se borra si algún país lo tiene asignado.',
      route: IDIOMAS_PATH,
    },
    {
      id: 'does-not-translate',
      title: 'Poner un idioma no traduce la app',
      body:
        'Es metadato del país: dice cuál es su idioma oficial. Los textos de la app y del ' +
        'panel no salen de aquí. Es lo que más se malinterpreta de esta pantalla, y la ' +
        'causa de esperar una traducción que no va a llegar.',
      target: 'admin.languages.list',
      placement: 'top',
      optionalTarget: true,
    },
  ],
};
